export var CURRENT_YEAR = new Date().getFullYear();
var endOfNextDecember = function () {
    var currentDate = new Date();
    var currentMonth = currentDate.getMonth();
    var endOfNextDecember = currentMonth < 12 ? new Date(CURRENT_YEAR, 12) : new Date(CURRENT_YEAR + 1, 12);
    return endOfNextDecember;
};
export default endOfNextDecember;
//# sourceMappingURL=endOfNextDecember.js.map